import React, { useState, Fragment } from 'react';
import * as Yup from 'yup';
import NumberFormat from 'react-number-format';
import numeral from 'numeral';
import { makeStyles } from '@material-ui/core/styles';
import { Formik } from 'formik';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Box,
    Grid,
    colors,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Avatar
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        color: colors.cyan[300],
        backgroundColor: colors.grey[200],
        width: 290,
        height: 290
    }
}));

const Transfer = ({ item, open, closeEdition, updateValues, dependencies }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Realizar Transferência de Estoque
                    </Typography>
                </DialogTitle>

                <DialogContent dividers={true}>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                codigo: Yup.string().max(20).required('A seleção da unidade é obrigatório'),
                                nome: Yup.string().required('O nome da unidade é obrigatório'),
                                TIPO: Yup.string().required('O Tipo do produto é obrigatório'),
                                UNIDADE: Yup.string().required('A Unidade do produto é obrigatória'),
                                custo: Yup.string().required('O Valor de Custo do produto é precisa ser informado'),
                                valor: Yup.number().min(0.0).required('O Valor do produto é obrigatório'),
                                instalacao: Yup.number().required('O Valor de Mão de Obra do produto é obrigatório'),
                                estoque: Yup.number().required("Estoque é obrigatório"),
                                qtd: Yup.number().required('Nova quantidade é obrigatória'),
                                qtdProduto: Yup.number().required('Nova quantidade é obrigatória'),
                            }
                            )
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Grid
                                    container
                                    xs="auto"
                                >

                                    <Grid
                                        item
                                        md={3}
                                        xs={12}
                                    >

                                        <Grid
                                            container
                                            spacing={2}
                                        >

                                            <Grid
                                                item
                                            >
                                                <Avatar variant='rounded' id="productImage" name="productImage"
                                                    className={classes.avatar}
                                                    onClick={() => { }}
                                                    src={(item.imagem) ? process.env.REACT_APP_REMOTE_REPO + '/products/' + item.imagem : null}
                                                >
                                                    Sem Imagem
                                                </Avatar>

                                            </Grid>

                                            <Grid
                                                item
                                            >

                                            </Grid>

                                            <Grid
                                                item
                                            >

                                            </Grid>

                                        </Grid>
                                        <br></br>

                                    </Grid>

                                    <Grid
                                        item
                                        md={9}
                                        xs={12}>

                                        <Grid
                                            container
                                            spacing={2}
                                            xs="auto"
                                        >
                                            <Grid
                                                item
                                                md={2}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.codigo && errors.codigo)}
                                                    fullWidth
                                                    required
                                                    label="Código"
                                                    margin="none"
                                                    name="codigo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.codigo}
                                                    variant="outlined"
                                                    InputProps={{ readOnly: true }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={10}
                                                xs={12}>

                                                <TextField
                                                    error={Boolean(touched.nome && errors.nome)}
                                                    fullWidth
                                                    required
                                                    label="Nome"
                                                    margin="none"
                                                    name="nome"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.nome}
                                                    variant="outlined"
                                                    InputProps={{ readOnly: true }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth margin="none" >
                                                    <InputLabel shrink htmlFor="TIPO" required>Classe de Produto</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.TIPO && errors.TIPO)}
                                                        value={values.TIPO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Classe de Produto"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'TIPO',
                                                            id: 'TIPO',
                                                            readOnly: true
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.types.map((tipo) => (
                                                            <MenuItem key={tipo.id} value={tipo.id}>{tipo.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="APLICACAO">Categoria</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.APLICACAO && errors.APLICACAO)}
                                                        value={values.APLICACAO}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Categoria"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'APLICACAO',
                                                            id: 'APLICACAO',
                                                            readOnly: true
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.applications.map((regiao) => (
                                                            <MenuItem key={regiao.id} value={regiao.id}>{regiao.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={4}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="marca">Marca</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        error={Boolean(touched.marca && errors.marca)}
                                                        value={values.marca}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Marca"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'marca',
                                                            id: 'marca',
                                                            readOnly: true
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.brandings.map((marca) => (
                                                            <MenuItem key={marca.id} value={marca.id}>{marca.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={9}
                                                xs={12}
                                            >
                                                <TextField
                                                    error={Boolean(touched.observacao && errors.observacao)}
                                                    fullWidth
                                                    label="Observações Sobre o Produto"
                                                    rows={2}
                                                    size={10}
                                                    length={512}
                                                    multiline
                                                    margin="none"
                                                    name="observacao"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.observacao}
                                                    variant="outlined"
                                                    InputProps={{ readOnly: true }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>


                                            <Grid
                                                item
                                                md="auto"
                                                xs="auto">

                                            </Grid>

                                            <Grid
                                                item
                                                md="auto"
                                                xs="auto">

                                            </Grid>

                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <Divider></Divider>
                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                                <NumberFormat
                                                    error={Boolean(touched.custo && errors.custo)}
                                                    fullWidth
                                                    required
                                                    label="Valor de Custo"
                                                    margin="none"
                                                    name="custo"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.custo}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputProps={{ readOnly: true }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                                <NumberFormat
                                                    error={Boolean(touched.valor && errors.valor)}
                                                    fullWidth
                                                    required
                                                    label="Valor Material"
                                                    margin="none"
                                                    name="valor"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.valor}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputProps={{ readOnly: true }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <NumberFormat
                                                    error={Boolean(touched.instalacao && errors.instalacao)}
                                                    required
                                                    fullWidth
                                                    label="Valor Instalação"
                                                    margin="none"
                                                    name="instalacao"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.instalacao}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputProps={{ readOnly: true }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="UNIDADE" required>Unidade</InputLabel>
                                                    <Select notched
                                                        autosize={true}
                                                        required
                                                        error={Boolean(touched.UNIDADE && errors.UNIDADE)}
                                                        value={values.UNIDADE}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        label="Unidade"
                                                        variant="outlined"
                                                        inputProps={{
                                                            name: 'UNIDADE',
                                                            id: 'UNIDADE',
                                                            readOnly: true
                                                        }}
                                                    >
                                                        <MenuItem value={null}>
                                                            <em>Selecione uma das opções abaixo</em>
                                                        </MenuItem>
                                                        {dependencies.units.map((unit) => (
                                                            <MenuItem key={unit.id} value={unit.id}>{unit.nome}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>


                                            <Grid
                                                item
                                                md={12}
                                                xs={12}>
                                                <Divider></Divider>
                                            </Grid>

                                            <Grid
                                                item
                                                md={5}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="idEstoque">Estoque de Origen</InputLabel>
                                                    <Select notched
                                                        error={Boolean(touched.idEstoque && errors.idEstoque)}
                                                        required={true}
                                                        fullWidth={true}
                                                        label="Estoque de Origen"
                                                        variant="outlined"
                                                        id="idEstoque"
                                                        name="idEstoque"
                                                        value={values.idEstoque}
                                                        onBlur={handleBlur}
                                                        onChange={(event) => {
                                                            values.idEstoque = event.target.value;
                                                            for (let index = 0; index < dependencies.stocks.length; index++) {
                                                                const element = dependencies.stocks[index];
                                                                if (element.id == event.target.value) {
                                                                    values.qtdProduto = element.qtd;
                                                                    values.qtdDestino = parseFloat(values.qtdProdutoDestino) + parseFloat(values.qtd);
                                                                }
                                                            }
                                                            handleChange(event);
                                                        }}
                                                        inputProps={{
                                                            name: 'idEstoque',
                                                            id: 'idEstoque',
                                                        }}
                                                    >

                                                        {dependencies.stocks.map((stock) => (
                                                            <MenuItem key={stock.id} value={stock.id}>{stock.nome} ( {numeral(stock.qtd).format('0.00')} )</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <NumberFormat
                                                    error={Boolean(touched.qtdProduto && errors.qtdProduto)}
                                                    required={true}
                                                    fullWidth
                                                    label="Quantidade Atual"
                                                    margin="none"
                                                    name="qtdProduto"
                                                    id="qtdProduto"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.qtdProduto}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputProps={{
                                                        name: "qtdProduto",
                                                        id: "qtdProduto",
                                                        readOnly: false
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <NumberFormat
                                                    error={Boolean(touched.qtd && errors.qtd)}
                                                    required
                                                    fullWidth
                                                    label="Quantidade a Transferir"
                                                    margin="none"
                                                    name="qtd"
                                                    id="qtd"
                                                    onBlur={(event) => {
                                                        values.qtdDestino = parseFloat(values.qtdProdutoDestino) + parseFloat(values.qtd);
                                                        handleBlur(event);
                                                    }}
                                                    onChange={handleChange}
                                                    value={values.qtd}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{
                                                        name: 'qtd',
                                                        id: 'qtd',
                                                        readOnly: false
                                                    }}
                                                />

                                            </Grid>


                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>


                                            </Grid>

                                            <Grid
                                                item
                                                md={5}
                                                xs={12}>

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>
                                               

                                            </Grid>

                                            <Grid
                                                item
                                                md={5}
                                                xs={12}>

                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="idEstoqueDestino">Estoque de Destino</InputLabel>
                                                    <Select notched
                                                        error={Boolean(touched.idEstoqueDestino && errors.idEstoqueDestino)}
                                                        required={true}
                                                        fullWidth={true}
                                                        label="Estoque de Destino"
                                                        variant="outlined"
                                                        id="idEstoqueDestino"
                                                        name="idEstoqueDestino"
                                                        value={values.idEstoqueDestino}
                                                        onBlur={handleBlur}
                                                        onChange={(event) => {
                                                            values.idEstoqueDestino = event.target.value;
                                                            for (let index = 0; index < dependencies.stocks.length; index++) {
                                                                const element = dependencies.stocks[index];
                                                                if (element.id == event.target.value) {
                                                                    values.qtdProdutoDestino = element.qtd;
                                                                    values.qtdDestino = parseFloat(values.qtdProdutoDestino) + parseFloat(values.qtd);
                                                                }
                                                            }
                                                            handleChange(event);
                                                        }}
                                                        inputProps={{
                                                            name: 'idEstoqueDestino',
                                                            id: 'idEstoqueDestino',
                                                        }}
                                                    >

                                                        {dependencies.stocks.map((stock) => (
                                                            <MenuItem key={stock.id} value={stock.id}>{stock.nome} ( {numeral(stock.qtd).format('0.00')} )</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <NumberFormat
                                                    error={Boolean(touched.qtdProdutoDestino && errors.qtdProdutoDestino)}
                                                    required={true}
                                                    fullWidth
                                                    label="Quantidade Atual"
                                                    margin="none"
                                                    name="qtdProdutoDestino"
                                                    id="qtdProdutoDestino"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.qtdProdutoDestino}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputProps={{
                                                        name: "qtdProdutoDestino",
                                                        id: "qtdProdutoDestino",
                                                        readOnly: true
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                />

                                            </Grid>

                                            <Grid
                                                item
                                                md={3}
                                                xs={12}>

                                                <NumberFormat
                                                    error={Boolean(touched.qtdDestino && errors.qtdDestino)}
                                                    fullWidth
                                                    label="Nova Quantidade"
                                                    margin="none"
                                                    name="qtdDestino"
                                                    id="qtdDestino"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.qtdDestino}
                                                    variant="outlined"
                                                    decimalScale="2"
                                                    fixedDecimalScale="true"
                                                    customInput={TextField}
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{
                                                        name: "qtdDestino",
                                                        id: "qtdDestino",
                                                        readOnly: false
                                                    }}
                                                />

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Grid>


                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Transfer;
